import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SolarPanel, Gear, Monitor, Battery } from '../components/Icons';
import './Solutions.css';

gsap.registerPlugin(ScrollTrigger);

const ITEMS = [
  { Icon: SolarPanel, title: 'Solar Kit and Installation', desc: 'End-to-end PV installation for homes, businesses, and industry.' },
  { Icon: Gear,       title: 'Engineering & Design',      desc: 'Custom-engineered systems tuned for maximum yield.' },
  { Icon: Monitor,    title: 'Operations & Maintenance',  desc: 'Monitoring and upkeep that keep output at its peak.' },
  { Icon: Battery,    title: 'Energy Storage',            desc: 'Battery storage that powers you through the night.' },
];

export default function Solutions() {
  const sectionRef = useRef(null);
  const headRef    = useRef(null);
  const cardsRef   = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(headRef.current.children, {
        opacity: 0, y: 16, duration: 0.7, stagger: 0.1, ease: 'power3.out',
        scrollTrigger: { trigger: sectionRef.current, start: 'top 72%' },
      });
      gsap.from(cardsRef.current, {
        opacity: 0, y: 30, duration: 0.7, stagger: 0.1, ease: 'power3.out',
        scrollTrigger: { trigger: sectionRef.current, start: 'top 64%' },
      });
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section className="section section--flow solutions-section" id="solutions" ref={sectionRef}>
      <div className="section-head" ref={headRef}>
        <p className="eyebrow">What we do</p>
        <h2 className="section-title">Our solar <span className="accent">solutions</span></h2>
      </div>

      <div className="container solutions-grid">
        {ITEMS.map(({ Icon, title, desc }, i) => (
          <article className="solution-card" key={i} ref={el => cardsRef.current[i] = el}>
            <span className="solution-icon"><Icon width="26" height="26" /></span>
            <h3 className="solution-title">{title}</h3>
            <p className="solution-desc">{desc}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
